import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  id: "app-main",
  class: "app-main"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createVNode(_component_router_view, null, {
    default: _withCtx(function (_ref) {
      var Component = _ref.Component;
      return [_createVNode(_Transition, {
        name: "fade-transform",
        mode: "out-in"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(), _createBlock(_KeepAlive, {
            include: $options.cachedViews
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: $options.key,
            class: "app-main__view"
          }))], 1032, ["include"]))];
        }),
        _: 2
      }, 1024)];
    }),
    _: 1
  })]);
}